import { css, cx } from "@emotion/css"
import React from "react"

import Anchor from "@p-ban/common/src/components/html/Anchor"
import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import mailImage from "./mail.png"
import questionImage from "./question.png"
import speechBalloonImage from "./speechBalloon.png"
import telImage from "./tel.png"

const FooterAddress = () => {
  return (
    <address className={styles.address}>
      <Image src={telImage} alt="フリーダイヤル 0120-439-296 営業時間 / 9:00～18:00(土日祝日定休)" />
      <Spacer size={15} />
      <div>
        <Anchor className={cx(styles.linkButton, styles.form)} href="/form/contact_form.html" target="_blank">
          <Image src={speechBalloonImage} alt="" />
          <Spacer size={5} />
          お問い合わせフォーム
        </Anchor>
        <Spacer size={5} />
        <Anchor className={styles.mail} href="mailto:info@p-ban.com">
          <Image src={mailImage} alt="info@p-ban.com" />
        </Anchor>
      </div>
      <span className={styles.border} />
      <Anchor className={cx(styles.linkButton, styles.faq)} href="/others/faq.html">
        <Image src={questionImage} alt="" />
        <Spacer size={5} />
        よくある質問
      </Anchor>
    </address>
  )
}

export default FooterAddress

const styles = {
  address: css`
    display: flex;
    justify-content: center;
    height: 87px;
    padding: 20px 0px 17px;
    border-bottom: 1px solid #037b09;
  `,
  border: css`
    margin: 0 15px;
    border-right: 1px solid #46ac4b;
    border-left: 1px solid #037b09;
  `,
  linkButton: css`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
    color: #555555;
    text-decoration: none;
    background-color: #ececec;
    border: 1px solid #cbcbcb;
    border-radius: 5px;
    &:hover {
      background-color: #fff;
      border: 1px solid #969696;
    }
  `,
  mail: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  form: css`
    width: 190px;
    height: 25px;
  `,
  faq: css`
    width: 341px;
    height: 47px;
  `,
}
